import styled from 'styled-components';

export const Link = styled.a`
  font-weight: bold;
  font-size: 16px;
  color: var(--primaryBlue);
  cursor: pointer;
`;
